
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetGrpoData = createAsyncThunk(
    'grpo/fetchGrpoData',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('PoNum/GetPONum');
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching GRPO data');
      }
    }
  );
  
  export const GetGrpoItmData = createAsyncThunk(
    'grpo/fetchGrpoItmData',
    async ({ DocEntry,PoEntry }, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`PoNum/GetItemByPo?DocEntry=${DocEntry}&POENTRY=${PoEntry}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching GRPO data');
      }
    }
  );

  export const PostItemCoilId = createAsyncThunk(
    'grpo/postItemCoilId',  // Action name for redux
    async (updatedRows, { rejectWithValue }) => {
      try {
        // Make the POST request with updatedRows as the payload
        const response = await apiClient.post('PoNum/ItemCoilIdPost', updatedRows);
        return response.data;  // Return the response data to be stored in Redux
      } catch (error) {
        // Handle the error and return it with rejectWithValue for better error handling
        return rejectWithValue(error.response?.data || 'Error posting GRPO');
      }
    }
  );
  export const PostedCoils = createAsyncThunk(
    'grpo/GetPostGrpo',  // Action name for redux
    async ({DocEntry,PoEntry}, { rejectWithValue }) => {
      try {
        // Make the POST request with updatedRows as the payload
        const response = await apiClient.get(`PoNum/GetPostedGRPo?DocEntry=${DocEntry}&POENTRY=${PoEntry}`);
        return response.data;  // Return the response data to be stored in Redux
      } catch (error) {
        // Handle the error and return it with rejectWithValue for better error handling
        return rejectWithValue(error.response?.data || 'Error posting GRPO');
      }
    }
  );